import { ReferFriendForm } from './refer-friend-form';

$(() => {
  const form = new ReferFriendForm();
  form.mount($('#refer_form'));
});
